// iOS screen control

var Model = require("../types/Model.js");
var window = require("global");
var Platform = require("react-native").Platform;
import { activateKeepAwake, deactivateKeepAwake } from "@sayem314/react-native-keep-awake";

module.exports = new Model({
	name: "keepawake",
	init: init,
	uninit: uninit,
	triggers: triggers,

	lock: lock,
	unlock: unlock,
});

function init() {
	// Say that it hasn't locked yet
	this.push(false);
}

function uninit() {
	// If not locked, don't worry about it
	if (!this.data) return;
	this.unlock();
}

function triggers() {
	return {
		lock: lock,
		unlock: unlock
	};
}

function lock() {
	if(activateKeepAwake && Platform.OS === "ios") {
		activateKeepAwake();
	} else {
		var plugin = window.plugins;
		if(!plugin || !plugin.insomnia) return;
		if(plugin.insomnia.keepAwake){
			plugin.insomnia.keepAwake();
		}
	}
	this.push(true);
}

function unlock() {
	if(deactivateKeepAwake && Platform.OS === "ios") {
		deactivateKeepAwake();
	} else {
		var plugin = window.plugins;
		if(!plugin || !plugin.insomnia) return;
		if(plugin.insomnia.allowSleepAgain){
			plugin.insomnia.allowSleepAgain();
		}
	}
	this.push(false);
}
